export default __webpack_public_path__ + "static/media/photosDefaultRight.fcd7f3db.webp";